import React from "react"
import { StaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import Img from "gatsby-image/withIEPolyfill"

class LoungeProviders extends React.Component {
  constructor() {
    super()
    this.state = { provider: 0 }
  }

  render() {
    const providersGlobal = this.props.globalJson.providers
    const providers = this.props.providers
    const title = this.props.title || providersGlobal.title
    const showDisclaimer = this.props.showDisclaimer

    return (
      <div className="providers container container--med island">
        <h2>{title}</h2>
        <p>{providersGlobal.intro}</p>
        <div className="provider-list island">
          <ul className="grid-wrapper">
            {providers.map( (provider, index) => {
              return (
                <li key={index} className="grid one-third lap-one-quarter">
                  <button className={this.state.provider === index ? 'provider-image is-active': 'provider-image'} onClick={() => this.setState({ provider: index})}>
                    <Img fluid={provider.logo.localFile.childImageSharp.fluid} alt={provider.name} />
                  </button>
                </li>
              )
            })}
          </ul>
        </div>
        {providers.map( (provider, index) => {
          return (
            <div key={index} className={this.state.provider === index ? 'provider-detail island--dubs is-active': 'provider-detail'}>
              <h3>{provider.name}</h3>
              <p className="landmarkless" dangerouslySetInnerHTML={{__html: provider.description}} />
              <p><a href={provider.linkUrl} target="_blank" rel="noopener noreferrer">{provider.linkText}</a></p>
            </div>
          )
        })}
        {showDisclaimer && providersGlobal.disclaimer &&
          <p>{providersGlobal.disclaimer}</p>
        }
      </div>
    )
  }
}

LoungeProviders.propTypes = {
  globalJson: PropTypes.shape({
    providers: PropTypes.object.isRequired,
  }).isRequired,
  providers: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        strapiCenturionGlobal {
          providers {
            title
            intro
            disclaimer
          }
        }
      }
    `}
    render={({ strapiCenturionGlobal, providers }) => <LoungeProviders globalJson={strapiCenturionGlobal} providers={providers} {...props} />}
  />
)
